// Sister-aware addressing for mixed / feminine obediences.
import { api } from "./api";

let _cached = null;
export async function fetchObedienceType() {
  if (_cached) return _cached;
  try {
    const { data } = await api.get("/lodge");
    _cached = data?.obedience_type || "regulara";
  } catch (_e) {
    _cached = "regulara";
  }
  return _cached;
}

export function isSisterMember(member, obedienceType) {
  if (obedienceType === "feminina") return true;
  return obedienceType === "mixta" && String(member?.sex || "").toUpperCase() === "F";
}

// Pick the plural-audience i18n key variant for the current obedience type:
// regulara → base, mixta → `${base}_mixed`, feminina → `${base}_sisters`.
export function pluralKey(base, obedienceType) {
  if (obedienceType === "mixta") return `${base}_mixed`;
  if (obedienceType === "feminina") return `${base}_sisters`;
  return base;
}
